module.exports = __webpack_public_path__ + "img/status-paid-active.48b75486.svg";